
import marked from 'marked';
import DOMPurify from 'dompurify';

export default {
  name: 'AppMarked',
  props: {
    text: { type: String, required: true },
    markdownOption: { type: Object, default: null }
  },
  computed: {
    markedText() {
      // \n\n을 단락 분리가 아닌 줄바꿈으로 처리
      const processedText = this.text.replace(/\n\n+/g, '<br><br>');
      return marked.parse(processedText, {
        ...this.markdownOption
      });
    }
  },
  created() {
    marked.use({ tokenizer: { del() {} } });

    DOMPurify.addHook('afterSanitizeAttributes', node => {
      if (node.tagName === 'A' && 'target' in node) {
        node.setAttribute('target', '_blank');
      }
    });
  },
  beforeDestroy() {
    DOMPurify.removeHook('afterSanitizeAttributes');
  }
};
